<template>
    <div class="datagrid-wrapper">
        <div id="centres-overview">
            <div class="row">
                <div class="col-md-12 title-holder">
                    <h1>{{ table_title }}</h1>
                    <div class="grid-buttons" data-type="filter">
                        <div class="dropdown">
                            <button class="dropdown-toggle btn btn-light" type="button" id="dropdownStatus" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ status_name }}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownStatus">
                                <li v-for="status in statuses">
                                    <a @click="filterStatus(status.value, status.name)" class="dropdown-item" href="#">
                                        {{ status.name }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="search-form-mask open">
                        <form role="search" method="get" class="form-inline search-form">
                            <div class="form-group">
                                <input v-model.lazy="search" class="sb-search-input form-control"
                                       placeholder="Search for.."/>
                            </div>
                            <div v-if="this.search">
                                <button @click.prevent="reset" type="reset" class="btn-icon btn-light sb-icon-reset">
                                <span class="fa fa-close">
                                    <span class="visually-hidden">Reset</span>
                                </span>
                                </button>
                            </div>
                            <button @click.prevent="getCentres" type="submit" class="btn btn-light sb-icon-search">
                            <span class="fa fa-search">
                                <span class="visually-hidden">Search</span>
                            </span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <table class="datagrid table">
                    <thead>
                    <tr>
                        <th v-for="header in table_headers">
                            <div v-if="header === 'name' || header === 'city'">
                                <button type="button" class="btn btn-link"  @click="sortBy('centres.' + header)">{{ header }} &#8597;</button>
                            </div>
                            <div v-else-if="header === 'country'">
                                <button type="button" class="btn btn-link" @click="sortBy('countries.country')">{{ header }} &#8597;</button>
                            </div>
                            <div v-else class="table-header">
                                <span class="btn-link">{{ header }}</span>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!centres.data">
                        <td :colspan="table_headers.length"><span class="spinner anim-spin"></span></td>
                    </tr>
                    <tr v-else-if="!centres.data.length">
                        <td :colspan="table_headers.length">No centres found</td>
                    </tr>
                    <tr v-for="centre in centres.data" v-bind:key="centre.id">
                        <td v-for="column in table_columns">
                            <div v-if="column === 'name'">
                                <a :href="`/centre/${centre.id}`">{{ centre.name }}</a>
                            </div>
                            <div v-else-if="column === 'status'">
                                <span :class="centre.status">{{ centre.status.split('_').join(' ') }}</span>
                            </div>
                            <div v-else-if="column === 'enable_remote_access'">
                                <centre-toggle-switch
                                    v-bind:configuration-key="'remoteAccess'"
                                    v-bind:centre-id='centre.id'
                                    v-bind:initial-value='centre.is_remote_access_enabled'>
                                </centre-toggle-switch>
                            </div>

                            <div v-else-if="column === 'manual_booking_sync'">
                                {{ centre.is_not_using_booking_sync ? 'disabled' : 'enabled' }}
                            </div>

                            <div v-else v-html="centre[column]">
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            <pagination :data="centres" :limit=3 @pagination-change-page="getCentres">
                                <template #prev-nav>
                                    <span>&lt; Previous</span>
                                </template>
                                <template #next-nav>
                                    <span>Next &gt;</span>
                                </template>
                            </pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CentresDataTable",
    props: {
        api_endpoint: {
            type: String,
        },
        table_title: {
            type: String,
        },
        table_headers: {
            type: Array,
        },
        table_columns: {
            type: Array,
        },
    },
    data() {
        return {
            centres: {},
            paginate: 10,
            search: '',
            statuses: [
                { value: "", name: "All statuses" },
                { value: "commissioning", name: "Commissioning" },
                { value: "operational", name: "Operational"},
                { value: "to_be_commissioned", name: "To be commissioned"},
                { value: "closed", name: "Closed"}
            ],
            status_value: '',
            status_name: 'All statuses',
            sort_key: 'centres.name',
            reverse: false,
        }
    },
    watch: {
        paginate: function (value) {
            this.getCentres();
        }
    },
    methods: {
        filterStatus(value, name) {
            this.status_value = value;
            this.status_name = name
            this.getCentres();
        },
        getCentres(page = 1) {
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    paginate: this.paginate,
                    status: this.status_value,
                    q: this.search,
                    sort_key: this.sort_key,
                    sort_direction: this.reverse ? 'DESC' : 'ASC',
                }
            })
                .then(response => {
                    this.centres = response.data;
                });
        },
        reset() {
            this.search = '';
            this.getCentres();
        },
        sortBy(sort_key) {
            this.reverse = (this.sort_key === sort_key) ? ! this.reverse : false;
            this.sort_key = sort_key;
            this.getCentres();
        },
    },
    created() {
        this.getCentres();
    }
}
</script>
<style scoped>
.btn-link,.btn-link:hover {
    letter-spacing: normal;
    padding: 0 30px 0 0;
    margin: 0;
    vertical-align: bottom;
    color: #babfbf;
    font-weight: bold;
    font-size: 11px;
    outline: none !important;
    border: 0;
    text-decoration: none;
}
</style>

